import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "./components/ui/sonner";

import V4Wrapper from "./pages/V4Wrapper";
import OnboardingFlow from "./pages/v4/V4OnboardingFlow";
import { initGA } from "./lib/analytics";

function App() {
  useEffect(() => { initGA(); }, []);

  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <AnimatePresence mode="wait">
          <Routes>
            {/* Root goes straight to V4 (Arjun's home) */}
            <Route path="/" element={<Navigate to="/v4" replace />} />

            {/* V4: standalone onboarding flow */}
            <Route path="/v4/onboarding" element={<OnboardingFlow />} />

            {/* V4: Final Demo (unified) */}
            <Route path="/v4/*" element={<V4Wrapper />} />

            {/* Any legacy path falls back to V4 */}
            <Route path="*" element={<Navigate to="/v4" replace />} />
          </Routes>
        </AnimatePresence>
      </BrowserRouter>
      <Toaster 
        position="bottom-right" 
        toastOptions={{
          style: {
            background: '#0F0F0F',
            border: '1px solid rgba(255,255,255,0.08)',
            color: '#F7F8FA'
          }
        }}
      />
    </div>
  );
}

export default App;
